import { ChConsent } from "@/modules/patients/information/consent/ch/ch-consent"
import { SofiaEnvironment } from "@/sofia-environment"
import { ContactChannel, Country } from "@/types/__generated__/union-types"

interface ConsentProps {
  patientId: string
  dataGuardPatientIdentifier: string
  phoneNumber: string | null
  isEditMode?: boolean
  contactChannel?: ContactChannel
  country?: Country
}

const FEATURE_NAME = "ManagePatientConsent"

const Consent = ({ country, ...rest }: ConsentProps) => {
  if (country === "DE" || SofiaEnvironment.DisabledFeatures.includes(FEATURE_NAME)) return null

  return <ChConsent {...rest} />
}
export { Consent, type ConsentProps }
